import type { MantineTransition } from "@mantine/core";

/** More pronounced pop for larger elements (e.g. spellcheck suggestions card) */
export const popUpTransition: MantineTransition = {
    in: { opacity: 1, transform: "scale(1) translateY(0)" },
    out: { opacity: 0, transform: "scale(0.92) translateY(16px)" },
    common: { transformOrigin: "center bottom" },
    transitionProperty: "transform, opacity",
};
